import moment from "moment";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, Card, Col, Row, Spinner } from "react-bootstrap";
import * as authActions from "../redux/actions/authAction";
import { toastify } from "./Toast";
import { ToastContainer } from "react-toastify";

const TextInterface = ({ textData, clientData }) => {
  const { userprofileData } = useSelector((state) => state.getProfileData);
  const [selectedId, setSelectedId] = useState(null);
  const [selectedClientPhoneNumber, setSelectedClientPhoneNumber] =
    useState(null);
  const [selectedClientTextData, setSelectedClientTextData] = useState(null);
  const [selectedClientData, setSelectedClientData] = useState(null);
  const [loadingOnSendBtn, setLoadingOnSendBtn] = useState(false);
  const [newMessage, setNewMessage] = useState("");
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();

  const formatDate = (date) => {
    const hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0"); // Adding leading zero if needed
    const ampm = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 || 12; // Convert to 12-hour format

    return `${formattedHours}:${minutes} ${ampm}`;
  };

  const filterMessages = (messages, phoneNumber) => {
    const filteredMessages = [];
    const uniqueDates = {};

    messages[phoneNumber].forEach((message, index) => {
      const date = new Date(message?.createdAt).toISOString().split("T")[0];

      if (index === 0 || !uniqueDates[date]) {
        uniqueDates[date] = true;
        filteredMessages.push({ dateSeparator: date });
      }

      filteredMessages.push(message);
    });

    setSelectedClientTextData(filteredMessages.reverse());
  };

  const loadChat = (i) => {
    setSelectedId(i);
    setSelectedClientPhoneNumber(clientData[i].phoneNumber);
    filterMessages(textData[i], clientData[i].phoneNumber);
    setSelectedClientData(clientData[i]);
    setNewMessage("");
  };

  const inputMessageHandler = (e) => {
    setNewMessage(e.target.value);
  };

  const onSendBtnHandler = async () => {
    const trimmedMessage = newMessage.trim();
    if (trimmedMessage === "") {
      setNewMessage("");
      toastify("error", "Message content empty.");
    } else {
      try {
        const body = {
          to: selectedClientPhoneNumber,
          body: newMessage,
        };
        dispatch(authActions.sendText(body));
        setNewMessage("");
      } catch (error) {
        toastify("error", "Error sending text");
      }
    }
  };

  useEffect(() => {
    if (selectedId) {
      loadChat(selectedId);
    }
  }, [textData]);

  return (
    <div className="row" style={{ width: "100%" }}>
      <ToastContainer />
      <div style={{ width: "30%" }}>
        <Card
          style={{
            height: "550px",
            overflowY: "scroll",
            overflowX: "hidden",
          }}
        >
          {clientData && textData && textData?.length === 0 ? (
            <h5
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                position: "absolute",
                width: "100%",
                top: "40%",
              }}
            >
              No Texts Yet.
            </h5>
          ) : (
            <>
              {clientData &&
                textData &&
                textData?.map((_, i) => (
                  <div
                    key={i}
                    className="chat-list-card w-100 d-flex align-items-center justify-content-start gap-3 p-3"
                    onClick={() => loadChat(i)}
                    style={{
                      backgroundColor: selectedId === i ? "#1b46b4" : "#FFFFFF",
                      color: selectedId === i ? "#FFFFFF" : "#000000",
                      cursor: "pointer",
                    }}
                  >
                    <img
                      src={"/img/group-logo-placeholder.png"}
                      className="coach-clients-data-img "
                      alt="EQWell placeholder logo"
                    />

                    <p className="m-0 clients-name-chatlist">
                      <strong>
                        {clientData[i]?.firstName} {clientData[i]?.lastName}
                      </strong>
                    </p>
                  </div>
                ))}
            </>
          )}
        </Card>
      </div>
      {selectedClientTextData &&
        selectedClientTextData[selectedClientPhoneNumber] !== null && (
          <div style={{ width: "70%" }}>
            <Card
              style={{
                height: "550px",
              }}
            >
              <Card.Header className="chat-client-username d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center  ">
                  <p className="font-weight-bold mt-3 ml-2 ">
                    {selectedClientData?.firstName}{" "}
                    {selectedClientData?.lastName}
                  </p>
                </div>
              </Card.Header>
              <Card.Body className="card-body-chat">
                <div className="">
                  <div className="chat-conversation ">
                    <ul className="list-unstyled">
                      <div
                        className="scrollbar"
                        style={{
                          height: "400px",
                        }}
                        //   ref={chatContainerRef}
                      >
                        {selectedClientTextData.length > 0 ? (
                          selectedClientTextData?.map((item, index) => {
                            const messageId = item.sid ? item.sid : item._id;
                            return item.dateSeparator ? (
                              <li key={index}>
                                <div className="separator">
                                  <div className="line"></div>
                                  <span>
                                    {moment(item.dateSeparator).format("ll")}
                                  </span>
                                  <div className="line"></div>
                                </div>
                              </li>
                            ) : (
                              <li
                                key={index}
                                id={`message-${messageId}`}
                                style={{
                                  width: "100%",
                                  display: "flex",
                                  justifyContent:
                                    item.direction === "outbound"
                                      ? "flex-end"
                                      : "flex-start",
                                }}
                              >
                                <div
                                  className="conversation-list"
                                  style={{
                                    width: "45%",
                                  }}
                                >
                                  <div style={{ width: "100%" }}>
                                    {item?.direction !== "inbound" ? (
                                      <div
                                        className="sender-message-bubble media"
                                        style={{
                                          justifySelf:
                                            item?.direction === "outbound"
                                              ? "flex-end"
                                              : "flex-start",
                                        }}
                                      >
                                        {
                                          <p
                                            style={{
                                              color: "grey",
                                              margin: "0px",
                                              fontSize: "12px",
                                            }}
                                          >
                                            {userprofileData?.data?.firstName}{" "}
                                            {userprofileData?.data?.lastName}
                                          </p>
                                        }
                                        <div className=" media-body">
                                          <div
                                            className="sender-msg py-2 px-3"
                                            id={`message-bubble-${messageId}`}
                                          >
                                            <p className="text-small mb-0 text-white text-justify">
                                              {item.messageContent}
                                            </p>
                                          </div>
                                          <p className="message-time small text-muted d-flex">
                                            Sent at{" "}
                                            {formatDate(
                                              new Date(item.createdAt)
                                            )}
                                          </p>
                                        </div>
                                      </div>
                                    ) : (
                                      <div>
                                        <p
                                          style={{
                                            color: "grey",
                                            margin: "0px",
                                            fontSize: "12px",
                                            textAlign: "left",
                                          }}
                                        >
                                          {selectedClientData?.firstName}{" "}
                                          {selectedClientData?.lastName}
                                        </p>

                                        <div className="media mb-3">
                                          <div className="reciever-message-bubble media-body ml-3">
                                            <div
                                              className="rcvr-msg py-2 px-3"
                                              id={`message-bubble-${messageId}`}
                                            >
                                              <p className="text-small mb-0 text-white text-justify">
                                                {item.messageContent}
                                              </p>
                                            </div>
                                            <p className="message-time small text-muted d-flex">
                                              Sent at{" "}
                                              {formatDate(
                                                new Date(item.createdAt)
                                              )}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </li>
                            );
                          })
                        ) : (
                          <h5
                            style={{
                              height: "90%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            {"No texts yet"}
                          </h5>
                        )}
                      </div>
                    </ul>
                    <div className=" chat-input-section">
                      <Row>
                        <Col>
                          <div className="position-relative">
                            <input
                              type="text"
                              className="form-control chat-input"
                              placeholder="Enter Message..."
                              onChange={inputMessageHandler}
                              value={newMessage}
                              // onKeyDown={handleKeypress}
                              autoFocus
                            />
                          </div>
                        </Col>
                        <Col className="col-auto">
                          <Button
                            type="button"
                            className="btn btn-rounded w-md me-2"
                            style={{ backgroundColor: "#1b46b4" }}
                            onClick={onSendBtnHandler}
                            disabled={loadingOnSendBtn}
                          >
                            {loadingOnSendBtn ? (
                              <span
                                className="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                              ></span>
                            ) : (
                              <>
                                <span className="d-none d-sm-inline-block">
                                  Send
                                </span>
                                <i className="mdi mdi-send" />
                              </>
                            )}
                          </Button>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
        )}
    </div>
  );
};

export default TextInterface;
